(function () {
  var root = document.querySelector('[data-sticky-access]');
  if (!root) return;
  var dock = root.querySelector('.mnl-sticky-access__dock');
  var trigger = root.querySelector('.mnl-sticky-access__button');
  var modal = root.querySelector('[data-mnl-waitlist]');
  var card = modal.querySelector('[role="dialog"]');
  var previous = [], wasLocked = false, opener = trigger;
  var hero = document.querySelector('.mnl-hero, .mnl-exp-hero, .mnl-hiw-hero, .mnl-ins-hero, .mnl-mem-hero');
  var footerSections = Array.from(document.querySelectorAll('.mnl-cta, .mnl-footer'));
  var themeFrame = 0;
  function updateTheme() {
    themeFrame = 0;
    var pastHero = hero ? hero.getBoundingClientRect().bottom <= 0 : window.scrollY >= window.innerHeight;
    var atFooter = footerSections.some(function (section) {
      return section.getClientRects().length && section.getBoundingClientRect().top < window.innerHeight;
    });
    dock.hidden = !pastHero || atFooter || !modal.hidden;
    if (dock.hidden) return;
    var rect = trigger.getBoundingClientRect();
    var elements = document.elementsFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
    var scene = null;
    for (var i = 0; i < elements.length; i++) {
      if (root.contains(elements[i])) continue;
      scene = elements[i].closest('[data-mnl-scheme]');
      if (scene) break;
    }
    root.classList.toggle('is-light', !!scene && scene.getAttribute('data-mnl-scheme') === 'light');
  }
  function scheduleTheme() {
    if (!themeFrame) themeFrame = requestAnimationFrame(updateTheme);
  }
  window.addEventListener('scroll', scheduleTheme, {passive:true});
  window.addEventListener('resize', scheduleTheme, {passive:true});
  window.addEventListener('pageshow', scheduleTheme);
  if (hero && window.ResizeObserver) new ResizeObserver(scheduleTheme).observe(hero);
  var schemes = new MutationObserver(scheduleTheme);
  document.querySelectorAll('[data-mnl-scheme]').forEach(function (scene) {
    schemes.observe(scene, {attributes:true, attributeFilter:['data-mnl-scheme']});
  });
  updateTheme();
  function fitModal() {
    if (modal.hidden) return;
    var viewport = window.visualViewport;
    var height = viewport ? viewport.height : window.innerHeight;
    var available = Math.min(height, root.getBoundingClientRect().height) - 24;
    var scale = Math.min(1, available / card.offsetHeight);
    card.style.top = ((viewport ? viewport.offsetTop : 0) + height / 2) + 'px';
    card.style.transform = 'translate(-50%,-50%) scale(' + Math.max(.1, scale) + ')';
  }
  window.addEventListener('resize', fitModal, {passive:true});
  if (window.ResizeObserver) new ResizeObserver(fitModal).observe(card);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitModal, {passive:true});
    window.visualViewport.addEventListener('scroll', fitModal, {passive:true});
  }
  function open() {
    if (!modal.hidden) return;
    opener = document.activeElement;
    // Lock theme content only: Shopify mounts its CAPTCHA challenge beside the modal.
    previous = Array.from(root.parentElement.children).filter(function (el) {
      return el !== root && el.matches('.shopify-section, main, header, footer');
    }).map(function (el) {
      var state = {el:el, inert:el.inert}; el.inert = true; return state;
    });
    wasLocked = document.documentElement.classList.contains('mnl-locked');
    document.documentElement.classList.add('mnl-locked');
    dock.hidden = true;
    modal.hidden = false;
    fitModal();
    card.focus({preventScroll:true});
  }
  function close() {
    modal.hidden = true;
    previous.forEach(function (state) { state.el.inert = state.inert; });
    if (!wasLocked) document.documentElement.classList.remove('mnl-locked');
    updateTheme();
    (opener && opener.isConnected ? opener : trigger).focus({preventScroll:true});
  }
  trigger.addEventListener('click', open);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mnl-subscribe-open], a, button');
    if (!button || root.contains(button) || button.closest('.mnl-header, .mnl-quiz, .mnl-footer__signup, [data-mnl-waitlist]')) return;
    var label = button.textContent.replace(/\s+/g, ' ').trim();
    if (button.hasAttribute('data-mnl-subscribe-open') || /early acces|waitlist/i.test(label)) {
      event.preventDefault();
      open();
    }
  });
  modal.querySelectorAll('[data-mnl-waitlist-dismiss]').forEach(function (el) { el.addEventListener('click', close); });
  modal.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var controls = Array.from(card.querySelectorAll('button,input:not([type="hidden"]),a[href]'));
    var first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === card)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  modal.querySelector('form').addEventListener('submit', function () {
    modal.querySelector('[data-mnl-waitlist-tags]').value = modal.querySelector('[data-mnl-waitlist-tags]').dataset.consentBase +
      (modal.querySelector('[data-mnl-waitlist-marketing]').checked ? ',newsletter,product-updates' : '');
  });
  if (modal.querySelector('[data-mnl-waitlist-feedback]')) open();
})();
